const setting = {
    state: {

    },
    getters: {

    },
    mutations: {

    },
    actions: {

    },
};

export default setting;